var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBelow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2041 17C13.4645 17 13.6885 16.9193 13.876 16.7578C14.0687 16.5964 14.165 16.3724 14.165 16.0859L14.1572 6.73438C14.1572 6.43229 14.0661 6.20052 13.8838 6.03906C13.7067 5.8724 13.4932 5.78906 13.2432 5.78906C13.0296 5.8099 12.8604 5.85417 12.7354 5.92188L9.96191 7.61719C9.74316 7.7474 9.63379 7.92969 9.63379 8.16406C9.63379 8.34115 9.69889 8.5 9.8291 8.64062C9.96452 8.78125 10.1234 8.85156 10.3057 8.85156C10.4307 8.85156 10.5505 8.81771 10.665 8.75L12.251 7.73438L12.2588 16.0859C12.2588 16.3724 12.3525 16.5964 12.54 16.7578C12.7275 16.9193 12.9489 17 13.2041 17Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelow);
export default __webpack_public_path__ + "static/media/below.40657718.svg";
export { ForwardRef as ReactComponent };